import React from 'react';
import { Trash2Icon, CheckIcon } from 'lucide-react';
import { useContent } from '../../ContentContext';
export function RequestManager() {
  const {
    requests,
    updateRequest,
    deleteRequest
  } = useContent();
  return <div data-id="element-190" data-mp="wwiqiqn0wag5">
      <h1 className="font-display text-3xl font-medium text-gray-900" data-id="element-191" data-mp="wwabas3fgt1s">Förfrågningar</h1>
      <p className="mt-2 text-sm text-gray-500" data-id="element-192" data-mp="rxz1uih1okk3">Alla beställningsförfrågningar som skickas via checkout landar här.</p>

      {requests.length === 0 ? <div className="mt-10 rounded-3xl border-2 border-dashed border-gray-200 p-16 text-center text-sm text-gray-400" data-id="element-193" data-mp="i8xl2q2odz52">
          Inga förfrågningar än.
        </div> : <div className="mt-10 space-y-5" data-id="element-194" data-mp="d7i2d4nz04pu">
          {requests.map(request => <article key={request.id} className="rounded-3xl bg-white p-8 shadow-premium" data-id="element-195" data-mp="9a3txf8460yw">
              <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-196" data-mp="48mt1jpmqeib">
                <div data-id="element-197" data-mp="3vgsconifuvak">
                  <div className="flex items-center gap-3" data-id="element-198" data-mp="3vg94hyilbl9q">
                    <h2 className="font-display text-xl font-medium text-gray-900" data-id="element-199" data-mp="36w0840epodls">{request.name || 'Namnlös förfrågan'}</h2>
                    {request.reference && <span className="rounded-full bg-gray-100 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gray-500" data-id="element-200" data-mp="2xvk6yxlfxik3">
                        {request.reference}
                      </span>}
                    <span className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider ${request.status === 'ny' ? 'bg-black text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-201" data-mp="3qlaqjm5udcnl">
                      {request.status}
                    </span>
                  </div>
                  <p className="mt-1 text-sm text-gray-500" data-id="element-202" data-mp="25768yhucqm8j">
                    {request.customerType === 'company' ? 'Företag' : 'Privat'} ·{' '}
                    {request.logistics === 'delivery' ? 'Leverans' : 'Upphämtning'} · {request.email || '—'}
                  </p>
                  <p className="mt-1 text-xs text-gray-400" data-id="element-203" data-mp="1q5pntfruk6eo">
                    {[request.date, request.time].filter(Boolean).join(' ') || 'Inget datum'} ·{' '}
                    {request.guests || '—'} gäster · {request.phone || 'Inget telefonnr'} · Inkom{' '}
                    {new Date(request.createdAt).toLocaleDateString('sv-SE')}
                  </p>
                  {request.address && <p className="mt-1 text-xs text-gray-400" data-id="element-204" data-mp="17bap7r9g6frd">{request.address}</p>}
                </div>
                <div className="flex items-center gap-2" data-id="element-205" data-mp="12geycufy5yfu">
                  <button onClick={() => updateRequest(request.id, {
              status: request.status === 'ny' ? 'hanterad' : 'ny'
            })} className="flex items-center gap-2 rounded-full bg-gray-100 px-4 py-2 text-xs font-medium text-gray-900 transition-colors hover:bg-gray-200" data-id="element-206" data-mp="ydqku9gag3cj">
                    <CheckIcon className="h-3.5 w-3.5" data-id="element-207" data-mp="2vbfsk8pj08mu" />
                    {request.status === 'ny' ? 'Markera hanterad' : 'Markera ny'}
                  </button>
                  <button onClick={() => deleteRequest(request.id)} aria-label="Ta bort förfrågan" className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition-colors hover:bg-red-50 hover:text-red-600" data-id="element-208" data-mp="308690x58t68s">
                    <Trash2Icon className="h-4 w-4" data-id="element-209" data-mp="2hbdi37jjshhm" />
                  </button>
                </div>
              </div>

              {request.notes && <p className="mt-5 rounded-2xl bg-gray-50 p-4 text-sm text-gray-600" data-id="element-210" data-mp="2m9ewhf613smr">{request.notes}</p>}

              {request.items.length > 0 && <ul className="mt-5 divide-y divide-gray-100 border-t border-gray-100" data-id="element-211" data-mp="2q9qkn1xlob2z">
                  {request.items.map((item, i) => <li key={i} className="flex items-center justify-between py-3 text-sm" data-id="element-212" data-mp="5kt0lxio6izi" data-mpi={i}>
                      <span className="text-gray-900" data-id="element-213" data-mp="43vqno8sqnhh">
                        {item.name}
                        <span className="ml-2 text-xs text-gray-400" data-id="element-214" data-mp="3vbrprjzbxpbf">{item.businessName}</span>
                      </span>
                      <span className="text-gray-600" data-id="element-215" data-mp="e3mi1h228mdc">
                        {item.quantity} × {item.price} kr
                      </span>
                    </li>)}
                  <li className="flex items-center justify-between pt-4 text-sm font-medium text-gray-900" data-id="element-216" data-mp="n2hpewguc2i8">
                    <span data-id="element-217" data-mp="i3omtz33dvwu">Totalt</span>
                    <span data-id="element-218" data-mp="i2lx3uhi9zii">{request.total} kr</span>
                  </li>
                </ul>}
            </article>)}
        </div>}
    </div>;
}